import * as api from "../Services/api.js";

export const state = {
  pageNumber: 0,
  posts: [],
  userData: {},
  orderBySort: null,
  totalPosts: 0,
  toggleShow: false,
  follower_count: 0,
};

export const mutations = {
  SET_FOLLOWER_COUNT(state, data) {
    state.follower_count = data;
  },
  SET_TOGGLE(state, data) {
    state.toggleShow = data;
  },
  SET_ORDERBY_SORT(state, orderBy) {
    state.orderBySort = orderBy;
  },
  SET_PROFILE_DATA(state, payload) {
    state.posts = payload.post_data.post_data;
    state.userData = { ...payload.user_data };
    for (let key in state.userData) {
      if (state.userData[key] === "null") state.userData[key] = "";
    }
    state.totalPosts = payload.post_count;
    state.pageNumber = 1;
  },
  SET_LOADED_PROFILE(state, payload) {
    state.posts = state.posts.concat(payload.post_data.post_data);
    state.pageNumber += 1;
  },
  CHANGE_PRESSURE(state, payload) {
    const index = state.posts.findIndex(
      ({ post_id }) => post_id === payload.post_id
    );
    state.posts[index].votes += payload.amount;
  },
  EDIT_POST(state, payload) {
    const index = state.posts.findIndex(
      ({ post_id }) => post_id === payload.post_id
    );
    state.posts.splice(index, 1, { ...payload });
  },
  REMOVE_POST(state, payload) {
    const index = state.posts.findIndex(({ uuid }) => uuid === payload);
    state.posts.splice(index, 1);
  },
};

export const getters = {
  getOrderBySort(state) {
    return state.orderBySort;
  },
};

export const actions = {
  async getProfileData({ commit }, data) {
    return await api
      .get(
        "/posts/profile/?uuid=" +
          data.id +
          "&page_num=" +
          data.pageNumber +
          "&active_tab=" +
          data.activeTab +
          "&show=" +
          data.show
      )
      .then((response) => {
        commit("SET_FOLLOWER_COUNT", response.follower_count);
        commit("SET_PROFILE_DATA", response);
        commit("SET_ORDERBY_SORT", response.order_by);
        commit("SET_TOGGLE", data.show);
        return response;
      });
  },
  async loadMorePosts({ commit, state, getters, dispatch }, data) {
    dispatch("setStatus", true, { root: true });
    const tmp = await api
      .get(
        "/posts/profile/?uuid=" +
          state.userData.uuid +
          "&page_num=" +
          state.pageNumber +
          "&active_tab=" +
          data.activeTab +
          "&order_by=" +
          getters.getOrderBySort +
          "&show=" +
          state.toggleShow
      )
      .then((response) => {
        dispatch("setStatus", false, { root: true });
        commit("SET_LOADED_PROFILE", response);
      });
    return tmp;
  },
  async changePressure({ commit }, data) {
    return await api
      .get(
        "/posts/change-vote/?post_id=" + data.post_id + "&amount=" + data.amount
      )
      .then((response) => {
        commit("CHANGE_PRESSURE", data);
        return response;
      });
  },
  async editPost({ commit }, data) {
    return await api.post("/posts/update/", data).then((response) => {
      if (response.status === 200) {
        commit("EDIT_POST", data);
      }
    });
  },
  async removePost({ commit }, data) {
    return await api.get("/posts/remove-post?uuid=" + data).then((response) => {
      if (response.status === 200) {
        commit("REMOVE_POST", data);
      }
    });
  },
  async profileTrack(_, data) {
    await api.post("/posts/profile-track/", data).then((response) => {
      console.log(response);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
